// extracted by mini-css-extract-plugin
export default {"container":"Errors_container__56VeC","error":"Errors_error__hS8zb"};